import React from "react";
import "./Realestatevaluation.css";
import License from '../../assets/WhatsApp Image 2025-04-05 at 18.58.14.jpeg'
import Footer from "../Footer";

const Realestatevaluation = () => {
  return (
    <>
    <div className="valuation-container">
      <h1 className="valuation-title">التثمين العقاري</h1>

      <section className="valuation-section">
        <p className="valuation-text">
        تقييم العقارات هو عملية تحديد القيمة الحالية للعقار بناءً على عوامل مختلفة مثل الموقع، واتجاهات السوق، والحالة المادية، والوضع القانوني. يُعدّ التقييم الدقيق للعقار أمرًا أساسيًا لاتخاذ قرارات الشراء والبيع والتأمين والضرائب والاستثمار. فهو يُساعد على ضمان تسعير عادل، ويحمي كلًا من المشترين والبائعين في معاملات العقارات.
        </p>
      </section>

      <section className="valuation-section">
        <h2 className="valuation-subtitle">عضوية مجلس المقيّمين المعتمدين رقم - 1210002400</h2>
        <p className="valuation-text">
        يُجري خدمات التقييم لدينا خبراء معتمدون ومرخصون من الهيئة السعودية للمقيمين المعتمدين (تقييم). وهذا يضمن أن جميع التقييمات تتبع المعايير الوطنية والممارسات الأخلاقية، مما يوفر تقييمات دقيقة وموثوقة للعقارات السكنية والتجارية.
        </p>
      </section>

      <section className="valuation-license">
        <h3 className="valuation-subtitle">الترخيص الرسمي</h3>
        <img
          src={License} 
          alt="Licensed Real Estate Valuation Certificate"
          className="license-image"
        />
      </section>
    </div>
    <Footer/>
    </>
  );
};

export default Realestatevaluation;
